import { useGLTF } from '@react-three/drei';
import { useEffect } from 'react';

export const WatchTower = () => {
  const gltf = useGLTF('/models/buildings/blue/building_watchtower_blue.gltf');

  useEffect(() => {
    gltf.scene.traverse((child: any) => {
      if (child.isMesh) {
        child.castShadow = true;
      }
    });
  }, [gltf]);

  return <primitive object={gltf.scene} position={[-3.9, 0, -3.4]} scale={[1, 1, 1]} castShadow />;
};
